import { ThemeConfig } from 'antd';

const filterConfig: ThemeConfig = {
  token: {
    fontFamily: 'inherit',
    fontSize: 14,
    colorPrimary: '#006D67',
  },
  components: {
    Collapse: {
      headerPadding: '0',
      contentPadding: '0',
    },
  },
};

export default filterConfig;
